/**
 * @generated SignedSource<<097bedf7a3609b022571168f08966cd7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetGenerationSettingsInput = {
  aspectRatio?: string | null;
  backgroundImageUrl?: string | null;
  backgroundPreset?: number | null;
  clothingImageUrl?: string | null;
  clothingPreset?: number | null;
  colorPreset?: number | null;
  ctaText?: string | null;
  durationSeconds?: number | null;
  effectPreset?: number | null;
  generateAudio?: boolean | null;
  guidanceScale?: number | null;
  height?: number | null;
  language?: string | null;
  layoutPreset?: number | null;
  maskImageUrl?: string | null;
  materialPreset?: number | null;
  model?: string | null;
  moodPreset?: number | null;
  negativePrompt?: string | null;
  personImageUrl?: string | null;
  personPreset?: number | null;
  posePreset?: number | null;
  prompt?: string | null;
  resolution?: string | null;
  scaleFactor?: number | null;
  seed?: number | null;
  sourceImageUrls?: ReadonlyArray<string> | null;
  steps?: number | null;
  strength?: number | null;
  styleImageUrl?: string | null;
  stylePreset?: number | null;
  subtitle?: string | null;
  surfacePreset?: number | null;
  title?: string | null;
  toolId?: string | null;
  toolName?: string | null;
  videoPreset?: number | null;
  width?: number | null;
};
export type assetLibraryQueriesSaveAssetToLibraryMutation$variables = {
  assetType: string;
  categoryID?: number | null;
  metadata?: AssetGenerationSettingsInput | null;
  name: string;
  sourceToolID?: string | null;
  sourceUrl: string;
};
export type assetLibraryQueriesSaveAssetToLibraryMutation$data = {
  readonly saveAssetToLibrary: {
    readonly assetType: string;
    readonly categoryID: number | null;
    readonly categoryName: string | null;
    readonly createdDate: string;
    readonly durationSeconds: number | null;
    readonly fileName: string;
    readonly filePath: string;
    readonly fileServerID: number;
    readonly fileSizeBytes: number | null;
    readonly fileUrl: string;
    readonly height: number | null;
    readonly id: string;
    readonly metadata: {
      readonly aspectRatio: string | null;
      readonly backgroundImageUrl: string | null;
      readonly backgroundPreset: number | null;
      readonly clothingImageUrl: string | null;
      readonly clothingPreset: number | null;
      readonly colorPreset: number | null;
      readonly ctaText: string | null;
      readonly durationSeconds: number | null;
      readonly effectPreset: number | null;
      readonly generateAudio: boolean | null;
      readonly guidanceScale: number | null;
      readonly height: number | null;
      readonly language: string | null;
      readonly layoutPreset: number | null;
      readonly maskImageUrl: string | null;
      readonly materialPreset: number | null;
      readonly model: string | null;
      readonly moodPreset: number | null;
      readonly negativePrompt: string | null;
      readonly personImageUrl: string | null;
      readonly personPreset: number | null;
      readonly posePreset: number | null;
      readonly prompt: string | null;
      readonly resolution: string | null;
      readonly savedAt: string | null;
      readonly scaleFactor: number | null;
      readonly seed: number | null;
      readonly sourceImageUrls: ReadonlyArray<string> | null;
      readonly steps: number | null;
      readonly strength: number | null;
      readonly styleImageUrl: string | null;
      readonly stylePreset: number | null;
      readonly subtitle: string | null;
      readonly surfacePreset: number | null;
      readonly title: string | null;
      readonly toolId: string | null;
      readonly toolName: string | null;
      readonly videoPreset: number | null;
      readonly width: number | null;
    } | null;
    readonly modifiedDate: string;
    readonly name: string;
    readonly sourceToolID: string | null;
    readonly thumbnailUrl: string | null;
    readonly width: number | null;
  };
};
export type assetLibraryQueriesSaveAssetToLibraryMutation = {
  response: assetLibraryQueriesSaveAssetToLibraryMutation$data;
  variables: assetLibraryQueriesSaveAssetToLibraryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadata"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceToolID"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceUrl"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "assetType",
        "variableName": "assetType"
      },
      {
        "kind": "Variable",
        "name": "categoryID",
        "variableName": "categoryID"
      },
      {
        "kind": "Variable",
        "name": "metadata",
        "variableName": "metadata"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "sourceToolID",
        "variableName": "sourceToolID"
      },
      {
        "kind": "Variable",
        "name": "sourceUrl",
        "variableName": "sourceUrl"
      }
    ],
    "concreteType": "AIAssetLibraryAssetDTO",
    "kind": "LinkedField",
    "name": "saveAssetToLibrary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceToolID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileServerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filePath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileSizeBytes",
        "storageKey": null
      },
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thumbnailUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetGenerationSettings",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prompt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "negativePrompt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "model",
            "storageKey": null
          },
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "strength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "steps",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guidanceScale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceImageUrls",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "styleImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maskImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clothingPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clothingImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "posePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surfacePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moodPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "materialPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "layoutPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stylePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scaleFactor",
            "storageKey": null
          },
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolution",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aspectRatio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateAudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ctaText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "savedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesSaveAssetToLibraryMutation",
    "selections": (v9/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*:: as any*/),
      (v3/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v4/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "assetLibraryQueriesSaveAssetToLibraryMutation",
    "selections": (v9/*:: as any*/)
  },
  "params": {
    "cacheID": "d69ec36720494da0261387688e746509",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesSaveAssetToLibraryMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesSaveAssetToLibraryMutation(\n  $sourceUrl: String!\n  $name: String!\n  $assetType: String!\n  $categoryID: Int\n  $sourceToolID: String\n  $metadata: AssetGenerationSettingsInput\n) {\n  saveAssetToLibrary(sourceUrl: $sourceUrl, name: $name, assetType: $assetType, categoryID: $categoryID, sourceToolID: $sourceToolID, metadata: $metadata) {\n    id\n    categoryID\n    name\n    assetType\n    sourceToolID\n    fileServerID\n    filePath\n    fileName\n    fileUrl\n    fileSizeBytes\n    width\n    height\n    durationSeconds\n    thumbnailUrl\n    metadata {\n      toolId\n      toolName\n      prompt\n      negativePrompt\n      model\n      width\n      height\n      seed\n      strength\n      steps\n      guidanceScale\n      sourceImageUrls\n      styleImageUrl\n      maskImageUrl\n      backgroundPreset\n      backgroundImageUrl\n      personPreset\n      personImageUrl\n      clothingPreset\n      clothingImageUrl\n      posePreset\n      effectPreset\n      surfacePreset\n      moodPreset\n      materialPreset\n      colorPreset\n      layoutPreset\n      stylePreset\n      videoPreset\n      scaleFactor\n      durationSeconds\n      resolution\n      aspectRatio\n      generateAudio\n      language\n      title\n      subtitle\n      ctaText\n      savedAt\n    }\n    createdDate\n    modifiedDate\n    categoryName\n  }\n}\n"
  }
};
})();

(node as any).hash = "5744eab788aeba880f69c45807946c5d";

export default node;
